import * as React from 'react';
import { SVGProps } from 'react';

const IconAxisYSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 13v1l3-1.5-3-1.5v1H9a.5.5 0 0 0-1 0H6a.5.5 0 0 0-1 0H2.5a.5.5 0 0 0 0 1H5a.5.5 0 0 0 1 0h2a.5.5 0 0 0 1 0h2Z"
      fill="var(--color-typo-system)"
    />
    <path
      d="M4 5h1L3.5 2 2 5h1v2a.5.5 0 0 0 0 1v2a.5.5 0 0 0 0 1v2.5a.5.5 0 0 0 1 0V11a.5.5 0 0 0 0-1V8a.5.5 0 0 0 0-1V5ZM6 3h1.512L8.97 5.819h.062L10.488 3H12L9.67 7.232V10H8.33V7.232L6 3Z"
      fill="var(--color-typo-normal)"
    />
  </svg>
);
export default IconAxisYSizeS;
